import { Trans, useLingui } from '@lingui/react'
import { type Dispatch, type ReactElement, type SetStateAction } from 'react'

import { type PageType } from 'types/cmsTypes'
import { type Tenant } from 'types/shopConfig'
import Modal from 'views/components/molecules/Modal'
import NowGlbZipModalForm from 'views/components/organisms/NowGlbZipModalForm'

interface INowZipModalBlueVariantProps {
  id: string
  open: boolean
  setModalOpen: Dispatch<SetStateAction<boolean>>
  zip: string
  pageType: PageType
  tenant: Tenant
}

const NowZipModalBlueVariant: (
  props: INowZipModalBlueVariantProps
) => ReactElement = ({ id, open, setModalOpen, zip, pageType, tenant }) => {
  const { i18n } = useLingui()
  return (
    <>
      {open ? (
        <Modal
          id={id}
          title={i18n._('general.label.nowGlobalBar.chooseLocation')}
          size="medium"
          light
          open={open}
          isClientSideControlled
          onHideModal={() => {
            setModalOpen(false)
          }}
        >
          <div>
            <div>
              <Trans id="general.label.nowGlobalBar.modalDescription" />
            </div>
            <br />
            <div>
              <Trans id="general.label.nowGlobalBar.enterZip" />
            </div>
          </div>
          <NowGlbZipModalForm
            open={open}
            i18n={i18n}
            setModalOpen={setModalOpen}
            zip={zip}
            pageType={pageType}
            tenant={tenant}
          />
        </Modal>
      ) : null}
    </>
  )
}

export default NowZipModalBlueVariant
